import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  position: absolute;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  bottom: 0;
  left: 0;
  right: 0;
`;
